jQuery.feature_import("js-meal-register-change",
  () => require("./meal-register-change.js"),
  mod => mod.feature_js_meal_register_change
);